import React from 'react';
import {View, Text, TouchableOpacity, Platform, StyleSheet, TextStyle} from 'react-native';
import {useSelector} from 'react-redux';
import {formatUsc} from '../../pipes';
import {useStyles} from '../../hooks/styles';
import {profileUscSelector} from '../../../redux/selectors/profile';
import {images} from '../../../assets/icons';
import {Props} from './model';
import {Text as CustomText} from '../text';
import {useTheme} from '../../theme';

const defaultIconSize = 24;

export default (props: Props) => {
  const theme = useTheme();
  const styles = useStyles(() => ({
    container: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      width: '100%',
    },
    textContainer: {
      flexGrow: 1,
      flexShrink: 0,
      overflow: 'visible',
    },
    number: {
      flexDirection: 'row',
      flexWrap: 'nowrap',
    },
    cardTitle: {
      ...theme.fonts.caption,
      color: theme.color.cardText,
    },
    button: {
      marginLeft: 'auto',
      paddingLeft: 10,
    },
    monospace: {letterSpacing: 5},
    code: {
      ...theme.fonts.h5,
      paddingRight: 7,
    },
  }));
  const {textStyle, style, iconProps, ...containerProps} = props;

  const code = useSelector(profileUscSelector());
  const [hidden, setHidden] = React.useState(true);
  const newIconProps = {
    ...(iconProps || {}),
    testID: `card-eye-${hidden ? 'hidden' : 'show'}-id`,
  };
  const numberStyle: TextStyle = StyleSheet.flatten([styles.code, textStyle]);
  const pointsStyle: TextStyle = StyleSheet.flatten([numberStyle, styles.monospace]);

  const PointsBlock = <Text style={pointsStyle}>••••</Text>;
  const Icon = hidden ? images.EyeOffFat : images.EyeFat;
  const iconColor = hidden
    ? props.hiddenIconColor || theme.color.primaryColor
    : props.visibleIconColor || theme.color.primaryColor;

  return (
    <TouchableOpacity
      testID='card-number-id'
      activeOpacity={1}
      onPress={() => setHidden(!hidden)}
      style={[style, styles.container]}
      {...containerProps}>
      <View style={styles.textContainer}>
        {props.useLabel ? (
          <CustomText type='label' style={styles.cardTitle}>
            Номер карты
          </CustomText>
        ) : null}
        {hidden ? (
          <View style={styles.number}>
            {PointsBlock}
            {PointsBlock}
            {PointsBlock}
            <Text style={numberStyle}>{code.slice(12)}</Text>
          </View>
        ) : (
          <Text style={[styles.code, textStyle]} numberOfLines={1}>
            {formatUsc(code)}
          </Text>
        )}
      </View>
      <View style={styles.button}>
        <Icon
          width={defaultIconSize}
          height={defaultIconSize}
          color={iconColor}
          strokeWidth={Platform.OS === 'web' ? 1 : 0}
          {...newIconProps}
        />
      </View>
    </TouchableOpacity>
  );
};
